import {
  GetFeatureInsightParams,
  GetFeatureTrendParams,
} from "@shared/models/http-request.model";

export class GetFeatureInsight {
  static readonly type = "[Feature insight] Get feature insight";
  constructor(public params: GetFeatureInsightParams) {}
}

export class GetFeatureTrend {
  static readonly type = "[Feature insight] Get feature trend";
  constructor(public params: GetFeatureTrendParams) {}
}
